module.exports = {
  HOST: {
    CL: 'https://www.falabella.com',
    PE: 'https://www.falabella.com.pe',
    CO: 'https://www.falabella.com.co',
    AR: 'https://www.falabella.com.ar',
    MX: 'https://www.sodimac.com.mx',
  },
  ENV_HOST: {
    CL: 'https://www.falabella.com',
    PE: 'https://www.falabella.com.pe',
    CO: 'https://www.falabella.com.co',
    AR: 'https://www.falabella.com.ar',
    MX: 'https://www.sodimac.com.mx',
  },
  FULL_HOST: {
    CL: 'https://www.falabella.com/falabella-cl',
    PE: 'https://www.falabella.com.pe/falabella-pe',
    CO: 'https://www.falabella.com.co/falabella-co',
    AR: 'https://www.falabella.com.ar/falabella-ar',
    CL_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl',
    CL_SO_COM: 'https://www.sodimac.cl/sodimac-cl',
    MX_SO_RETAIL: 'https://www.sodimac.com.mx/sodimac-mx',
    CL_TO_COM: 'https://www.tottus.cl/tottus-cl',
    CL_LINIO: 'https://linio.falabella.com/linio-cl',
    CL_TOTTUS: 'https://tottus.falabella.com/tottus-cl',
    CL_TIENDA: 'https://tienda.falabella.com/falabella-cl',
    CL_FA_AMERICA: 'https://www.americanino.cl/americanino-cl',
    CL_FA_ALDO: 'https://www.aldo.cl/aldo-cl',
    CL_FA_CARTERS: 'https://www.carters.cl/carters-cl',
    CL_FA_CRABARR: 'https://www.crateandbarrel.cl/crateandbarrel-cl',
    PE_LINIO: 'https://linio.falabella.com.pe/linio-pe',
    PE_TOTTUS: 'https://tottus.falabella.com.pe/tottus-pe',
    PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe',
    PE_SO_COM: 'https://www.sodimac.com.pe/sodimac-pe',
    PE_TO_COM: 'https://www.tottus.com.pe/tottus-pe',
    PE_TIENDA: 'https://tienda.falabella.com.pe/falabella-pe',
    CO_LINIO: 'https://linio.falabella.com.co/linio-co',
    CO_TOTTUS: 'https://tottus.falabella.com.co/tottus-co',
    CO_SODIMAC: 'https://sodimac.falabella.com.co/sodimac-co',
    CO_TIENDA: 'https://tienda.falabella.com.co/falabella-co',
    CO_HOMECENTER: 'https://homecenter.falabella.com.co/homecenter-co',
  },
  TAXONOMY: '{host}/rest/model/falabella/rest/browse/BrowseActor/get-header-main-menu',
  TYPEAHEAD: 'https://www.falabella.com/s/typeahead/v3/{value}?source=web&country={region}',
  SEARCH: 'https://dev.falabella.com/fa/search/v1/{region}?{query}',
  HEADER: '{host}/rest/model/falabella/rest/browse/BrowseActor/fetch-header',
  FOOTER: '{host}/rest/model/falabella/rest/browse/BrowseActor/fetch-footer',
  EMAIL_SUBSCRIPTION: '{host}/rest/model/falabella/rest/common/CommonActor/subscribe-to-newsletter',
  LOCATIONS: 'http://35.230.186.49/fa/geo/zones/v1/falabella-{region}',
  IMAGES: {
    CL: 'https://falabella.scene7.com/is/image/Falabella/',
    CO: 'https://falabella.scene7.com/is/image/FalabellaCO/',
    PE: 'https://falabella.scene7.com/is/image/FalabellaPE/',
    AR: 'https://falabella.scene7.com/is/image/FalabellaAR/',
  },
  BANNER_MC: {
    CL: 'https://www.falabella.com/static/RDF/site/noResults/banner/bannerMC.html',
    CO: 'https://www.falabella.com/static/RDF/site/noResults/banner/bannerMC.html',
    AR: 'https://www.falabella.com/static/RDF/site/noResults/banner/bannerMC.html',
    PE: 'https://www.falabella.com/static/RDF/site/noResults/banner/bannerMC.html',
  },
  CATEGORY_BANNER: {
    CL: '{host}/static/RDF/site/noResults/banner/CategoryBanner.html',
    CO: '{host}/static/RDF/site/noResults/banner/bannerMC.html',
    AR: '{host}/static/RDF/site/noResults/banner/bannerMC.html',
    PE: '{host}static/RDF/site/noResults/banner/bannerMC.html',
    MX: '{host}/static/RDF/site/noResults/banner/bannerMC.html',
  },
  SESSION_INFO: 'https://www.falabella.com/rest/model/atg/userprofiling/ProfileActor/fetchSessionInfo',
  TAG_MANAGER: {
    CL: '//assets.adobedtm.com/launch-EN3841a4834dd64c6bb9a812af8974e1cf.min.js',
    CO: '//assets.adobedtm.com/launch-ENefc886d6d08e45f1bcd6648ffbf43a9e.min.js',
    PE: '//assets.adobedtm.com/launch-EN12f948db3c6f482ca78e0ec9ef1c7fe0.min.js',
    AR: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
  },
  ANALYTICS_INFO: '{host}/rest/model/falabella/rest/common/CommonActor/analytics-info',
  EAN_TO_SKU:
    '{host}/rest/model/falabella/rest/browse/BrowseActor/scan-sku-details?{"productCode":"{code}","flagScanner":true,"codeType":"EAN"}',
  ITEMS_DETAILS:
    '{host}/rest/model/falabella/rest/browse/BrowseActor/fetch-item-details?{"products":[{"skuId":{skuId},"mediaType":"basic"}]}',
  PRODUCT_VARIATIONS: '{host}/rest/model/falabella/rest/browse/BrowseActor/storeItemInfo?{"skuId":"{skuId}"}',
  VENDOR_LOGOUT: 'https://facl-master-27d9c429-71320.test.falabella.com/falabella-{region}/includes/vendorLogout.jsp',
  VENDOR_NEW_CUSTOMER:
    'https://facl-master-27d9c429-71320.test.falabella.com/agentLocal/search.jsp?CJSESSIONID=PXwIJGIAHZS1ce5VkR08ULaW.node1&CURRENCYCODE=CLP&fromPage=&DPSLogout=true',
  VENDOR_HOME: '{host}/falabella-{region}/page/Guided-Selling?staticPageId=26000001',
  USER_SESSION_INFO: '{host}{url}',
  USER_LOGOUT: '{host}{url}',
  USER_LOGOUT_FOR_VENDOR:
    'https://facl-master-27d9c429-71320.test.falabella.com/falabella-{region}/includes/customerLogout.jsp',
  404: '{host}/falabella-{region}/error/404.html',
  500: '{host}/falabella-{region}/error/500.jspx',
  409: '{host}/falabella-{region}/error/409.jsp',
  INSTANA: '//eum.instana.io/eum.min.js',
  INSTANA_REPORTING: 'https://eum-us-west-2.instana.io',
  CATEGORY_PAGE: '{full_host}/category/{categoryId}/{categoryName}',
  SA_CATEGORY_PAGE: '{full_host}/lista/{categoryId}/{categoryName}',
  SEARCH_PAGE: '{full_host}/search?Ntt={searchTerm}',
  SA_SEARCH_PAGE: '{full_host}/buscar?Ntt={searchTerm}',
  COLLECTION_PAGE: '{full_host}/collection/{collectionId}',
  SA_COLLECTION_PAGE: '{full_host}/seleccion/{collectionId}',
  SELLER_PAGE: '{full_host}/seller/{sellerName}',
  SA_COM_SELLER_PAGE: '{full_host}/vendedor/{sellerName}',
  BRAND_PAGE: '{full_host}/brand/{brandName}',
  SA_BRAND_PAGE: '{full_host}/marca/{brandName}',
  BAZAARVOICE_SCRIPT_URL: {
    CL: 'https://apps.bazaarvoice.com/deployments/Falabella/main_site/production/es_CL/bv.js',
    CO: 'https://apps.bazaarvoice.com/deployments/Falabella-CO/main_site/production/es_CO/bv.js',
    PE: 'https://apps.bazaarvoice.com/deployments/Falabella-PE/main_site/production/es_PE/bv.js',
    AR: 'https://apps.bazaarvoice.com/deployments/Falabella-AR/main_site/production/es_AR/bv.js',
  },
  PLAN_URL: '/falabella-cl/plans/{productId}/{productName}/{variantId}',
  APERTURA_URL_VALID_CMR:
    'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
  APERTURA_URL_INVALID_CMR:
    'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
  ATG_LOGIN_URL: '{full_host}/myaccount/includes/loginForm.jsp',
};
